module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAOdEVYdFNvZnR3YXJlAEZpZ21hnrGWYwAAAOFJREFUeAHFlGsNwjAUhW8X/gMOhgQczMFwAA7oJKAAUDANKMACDloHw0E5N+uSwkIfo2QnOWm25H49vX0Q/UvGmD3cmXQprh04wgEqDA/4Rmmq4UoIsf5MyDpQoriGC4fvgjKrCMx+TE0dSniBW9v4kjIAWSc7MrQNgWOAGju4wdjAO/jua0P0pgDKy9/CK+rbUP4EBKDidBbYYAI9FbgE7GxhmlPatMEEo4PtXC++kvJL3dvBXpBfV+qXKJHqSRHyAgGRlKjsV89NyEuqnXbEil8bPfprm6tMujoz4ZWaTy/8QeQyqlzGAQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/video.png
// module id = BXki
// module chunks = 1